import React from 'react';
import { ChowLogo, LargeLogo } from '../assets/images';
import '../styles/CookieConsent.css';

interface CookieConsentProps {
    onAccept: () => void;
    onReject: () => void;
}

const CookieConsent: React.FC<CookieConsentProps> = ({ onAccept, onReject }) => {
    const handleReject = () => {
        // Call the onReject callback first, then redirect
        onReject();
        // Redirect to www.openscore.org.uk
        window.location.href = 'https://www.openscore.org.uk';
    };

    return (
        <div className="cookie-consent-overlay">
            <div className="cookie-consent-modal">
                <div className="cookie-consent-header">
                    <div className="cookie-consent-support">
                        <img
                            src={LargeLogo}
                            alt="OpenScore Map"
                            className="cookie-consent-brand-image"
                        />
                        <a
                            href="https://www.championingsocialcare.org.uk/care-home-open-week/about/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="cookie-consent-support-link"
                            aria-label="Open the Care Home Open Week page"
                        >
                            <div className="cookie-consent-support-copy">
                                <span className="cookie-consent-support-prefix">OpenScore Map: Proudly supporting</span>
                                <span className="cookie-consent-support-title">Care Home Open Week</span>
                                <span className="cookie-consent-support-dates">15th to 21st June 2026</span>
                            </div>
                            <img
                                src={ChowLogo}
                                alt="Care Home Open Week"
                                className="cookie-consent-support-image"
                            />
                        </a>
                    </div>
                </div>
                <div className="cookie-consent-body">
                    <p>
                        We&apos;ve made it simple to step inside local care homes and find out more
                        for yourself.
                    </p>
                    <ol className="cookie-consent-steps">
                        <li>
                            Search by postcode or location to see all the care homes taking part
                            in Care Home Open Week in your area.
                        </li>
                        <li>
                            Click on individual homes to find out more about what they have
                            planned, contact them directly, or add specific event dates to your
                            calendar so you don&apos;t miss out.
                        </li>
                    </ol>
                    <p className="cookie-consent-note">
                        By accepting, you agree to our use of cookies, including remembering your
                        last search details and storing analytics preferences. You can change your
                        preferences at any time by clearing your browser cookies.
                    </p>
                </div>
                <div className="cookie-consent-actions">
                    <button 
                        className="cookie-consent-btn cookie-consent-reject"
                        onClick={handleReject}
                    >
                        Reject All
                    </button>
                    <button 
                        className="cookie-consent-btn cookie-consent-accept"
                        onClick={onAccept}
                    >
                        Accept All
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieConsent;
